import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

import { DialogSendConfig } from "../../../../dialogs/dialog-send-config/dialog-send-config";

@Component({
  selector: "send-config-item",
  templateUrl: "send-config-item.html",
  styleUrl: "../../shortcut-menu.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule],
})
export class SendConfigItem {
  private dialog = inject(MatDialog);

  readonly subscriptionId = input.required<string>();

  protected openSendConfigDialog() {
    this.dialog.open(DialogSendConfig, {
      data: { subscriptionId: this.subscriptionId() },
    });
  }
}
